import { forwardRef, ReactNode } from 'react';
import { default as ReCAPTCHA } from 'react-google-recaptcha';

import { Config } from '@sternum/web/config';

import { CaptchaWrapper, ErrorMessage } from './GoogleRecaptcha.styles';

export interface GoogleRecaptchaProps {
  onSuccess: (token: string | null) => unknown;
  onError?: () => unknown;
  errorText?: ReactNode;
}

export type RecaptchaRef = ReCAPTCHA;

export const GoogleRecaptcha = forwardRef<ReCAPTCHA, GoogleRecaptchaProps>(function GoogleRecaptchaComponent(
  { onSuccess, onError, errorText }: GoogleRecaptchaProps,
  ref,
) {
  return (
    !Config.featureFlags?.disableRecaptcha && (
      <div>
        <CaptchaWrapper>
          <ReCAPTCHA
            ref={ref}
            sitekey={Config.google.recaptchaKey}
            onChange={onSuccess}
            onExpired={onError}
            onErrored={onError}
          />
        </CaptchaWrapper>

        {errorText && <ErrorMessage>{errorText}</ErrorMessage>}
      </div>
    )
  );
});
